import ReactDOM from 'react-dom/client';
import Root from './Root';

const rootRender = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
rootRender.render(<Root />);
